import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Login from "@/pages/login/page";
import RequireAuth from "@/components/auth/RequireAuth";
import GuestOnly from "@/components/auth/GuestOnly";
import PlannerListPage from "@/pages/planners/PlannerListPage";
import AdminLayout from "@/layouts/AdminLayout";
import ShopListPage from "@/pages/dressShop/ShopListPage";
import ReservationListPage from "@/pages/reservations/page";
import AdminShopSlotUsagePage from "@/pages/dressShop/ShopSlotUsagePage";
import CafeArticleReviewAdminPage from "@/pages/cafe/CafeArticleReviewAdminPage";
import AdminShopPreviewPage from "@/pages/cafe/AdminShopPreviewPage";
import PartnerShopEditorPage from "@/pages/cafe/PartnerShopEditorPage";
import PartnerShopListPage from "@/pages/partner/PartnerShopListPage";
import PartnerCreatePage from "@/pages/partner/PartnerCreatePage";
import PlannerReservationTransferPage from "@/pages/reservations/PlannerReservationTransferPage";
const routes: RouteObject[] = [
  {
    element: <GuestOnly />,
    children: [
      {
        path: "/login",
        element: <Login />,
      },
    ],
  },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <AdminLayout />,
        children: [
          {
            path: "/",
            element: <Navigate to='/planners' replace />
          },
          {
            path: "/planners",
            element: <PlannerListPage />
          },
          {
            path: "/shops",
            element: <ShopListPage />
          },
          {
            path: "/reservations/usage",
            element: <AdminShopSlotUsagePage />
          },
          {
            path: "/reservations/list",
            element: <ReservationListPage />
          },
          {
            path: "/reservations/transfer",
            element: <PlannerReservationTransferPage />
          },
          {
            path: "/navi/detail",
            element: <PartnerShopEditorPage />
          },
          {
            path: "/partner-shops",
            element: <PartnerShopListPage />
          },
          {
            path: "/partner-shops/new",
            element: <PartnerCreatePage />
          },
        ]
      },
      {
        path: "/cafe/articles",
        element: <CafeArticleReviewAdminPage />
      },
      {
        path: "/cafe/shops/:id",
        element: <AdminShopPreviewPage />
      },
      
    ],
  },
  
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
